const resultAbstractParts = {
	A1: 'une femme',
	A2: 'un homme',
	A3: '',
	B1: 'humide',
	B2: 'montagneux',
	B3: 'sec',
	B4: 'tropical',
	B5: 'temperé',
	B6: 'très ensoleillé',
	B7: 'urbain',
	C1: 'pollué',
	C2: 'non pollué',
	E1: 'son visage',
	E2: 'son corps',
	E3: 'ses mains et pieds',
	E4: 'ses cheveux',

	concernedAbout: {
		A1: 'soucieuse de',
		A2: 'soucieux de'
	}
}

export default {
	localeName: 'Français',
	mailForm: {
		heading:
			'L’OFFICINE UNIVERSELLE BULY EST UN MONDE VASTE ET MERVEILLEUX À DÉCOUVRIR SI VOTRE CURIOSITÉ EST GRANDE ET VOTRE ATTRAIT POUR LA BEAUTÉ INSATIABLE. POUR UNE INTRODUCTION DANS LES RÈGLES DE L’ART, VEUILLEZ INSCRIRE VOS COORDONNÉES.',
		firstNamePlaceholder: 'Prénom',
		emailPlaceholder: 'E-mail',
		submissionSuccess:
			'Votre abonnement a été confirmé. Veuillez vérifier votre courrier.',
		submissionFail:
			'Une erreur est survenue. Veuillez réessayer plus tard.',
		confirm: 'confirmer',
		dataConsent_start:
			"Je donne mon consentement et j'autorise Office Buly à",
		dataConsent_allow_send_recap:
			'm’envoyer les résultats de la consultation Skin Concierge par mail',
		dataConsent_allow_collect:
			'collecter, stocker et utiliser mes données personnelles et potentiellement sensibles afin de compléter le Skin Concierge afin de vous faire une recommandation Skin Concierge sur-mesure',
		marketingConsent:
			"m'envoyer des informations personnalisées et exclusives sur l'actualité Officine Universelle Buly",
		infoText_0:
			'Officine Universelle Buly est le responsable du traitement des données à caractère personnel que vous fournissez lors de votre diagnostic beauté. Vos données personnelles et potentiellement sensibles sont traitées par Officine Universelle Buly, sous réserve de votre consentement, pour gérer votre diagnostic beauté. Elles peuvent également être utilisées, avec votre consentement préalable, pour vous envoyer des informations, actualités ou événements personnalisés concernant notre marque. Ces données seront rattachées à votre compte client',
		infoText_1:
			"Vous pouvez exercer vos droits et également retirer votre consentement à tout moment. Pour plus d'informations sur vos données personnelles, veuillez consulter notre",
		infoText_2: 'Politique de confidentialité',
		infoText_2_href: 'https://buly1803.com/pages/privacy-policy',
		infoText_3:
			'ou contacter notre Délégué à la protection des données ici',
		infoText_4: 'privacy@buly1803.com',
		infoText_4_href: 'mailto:privacy@buly1803.com',
		loading: 'Envoi en cours...'
	},
	resultForm: {
		confirm: 'confirmer'
	},
	result: {
		title: 'Les recommandations de l’Officine',
		cta: 'Miroir, mon gentil miroir, quels sont mes résultats ?',
		button: 'Découvrir mes résultats',
		concern: 'Ma préoccupation',
		select: 'Sélectionner',
		unselect: 'Retirer',
		addCart: 'Voir mon panier',
		newSearch: 'Nouvelle recherche',
		question: 'Une question ?',
		recommend: 'Recommander à un ami',
		shops: 'Nos boutiques',
		discover: 'Discover',
		skip: 'Ignorer',
		showMore: 'Voir plus',
		tip: "Le conseil avisé de l'Officine",
		endTitle: 'Beauté naturelle'
	},
	loading: 'Chargement',
	questions: {
		extra: {
			id: 'extra',
			bulyImage: '/img/portraits/portrait-skin.jpg',
			title: 'Quelle est la teinte de votre peau ?',
			analyticSlug: '0-what-is-your-skin-tone'
		}
	},
	diagnosis: {
		onTheWay: 'Notre diagnostic est en cours',
		skip: 'Ignorer'
	},
	care_tag: {
		Care_Morning: 'Soin du matin',
		Care_Regular: 'Soin régulier',
		Care_Occasional: 'Soin occasionnel',
		Care_Evening: 'Soin du soir',
		Care_Daily: 'Soin quotidien',
		Care_Morning_Evening: 'Soin du matin et du soir'
	},
	store: 'https://www.buly1803.com/?concierge=',
	klaviyoId: 'WGVhR8',
	resultAbstract: ctx =>
		`Vous êtes ${
			resultAbstractParts[ctx.named('gender')]
		} qui vit dans un environement ${
			resultAbstractParts[ctx.named('climate1')]
		} et ${resultAbstractParts[ctx.named('climate2')]}, ${
			resultAbstractParts.concernedAbout[ctx.named('gender')]
		} ${resultAbstractParts[ctx.named('concern')]}`
}
